import { useCallback, useState } from 'react';
import { APPROVAL_V2_URL } from '@/constant/approval';
import type {
  CreateApprovalRequest,
  CreateApprovalResponse,
} from '@/types/approval';
import { postDataFetcher } from '@/utils/apis';

export type UseCreateApprovalOptions = {
  onSuccess?: (response: CreateApprovalResponse) => void;
  onError?: (error: unknown) => void;
};

/**
 * 품의 작성/제출 mutation.
 * - POST /api/v2/approval
 * - status: 'DRAFT' (임시저장) | 'SUBMIT' (결재 진행 시작)
 */
const useCreateApproval = (options?: UseCreateApprovalOptions) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const create = useCallback(
    async (payload: CreateApprovalRequest): Promise<CreateApprovalResponse> => {
      setIsSubmitting(true);
      try {
        const response = await postDataFetcher<
          Record<string, unknown>,
          Record<string, unknown>
        >(APPROVAL_V2_URL, payload as Record<string, unknown>);
        options?.onSuccess?.(response);
        return response as CreateApprovalResponse;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      } finally {
        setIsSubmitting(false);
      }
    },
    [options],
  );

  return { create, isSubmitting };
};

export default useCreateApproval;
